<template>
  <div class="stale-item-alert" @click="$emit('refresh-requested')">
    <p class="small center">
      <strong>This {{ TextAssistant.itemSingularName(entityType).toLowerCase() }} has been updated!</strong>
      <br>
      <u>Click here to refresh</u>.
    </p>
  </div>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'
import { EEntities } from '@/types'
import TextAssistant from '@/helpers/text-assistant'

export default defineComponent({
  name: 'StaleItemAlert',

  props: {
    entityType: {
      type: String as () => EEntities,
      required: true,
    },
  },

  emits: ['refresh-requested'],

  data() {
    return {
      TextAssistant,
    }
  },
})
</script>


<style lang="scss">
.stale-item-alert {
  position: fixed;
  cursor: pointer;
  bottom: 0;
  right: 0;
  background-color: $color--gray-90;
  color: $color--white;
  margin: 0 20px 20px 0;
  padding: 10px 20px;
  border-radius: 8px;
  z-index: 1050;

  animation-name: dd-bounce;
  animation-duration: 0.5s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: 2;

  > p.small {
    color: $color--white;
  }
}
</style>
